import { YEAR_GROUPS } from '../../constants';
import * as actions from './actions';

const initialState = {
    years: YEAR_GROUPS,
    defaultCourses: {},
    courses: [],
    dataSaved: true,
    saveSuccessful: null
};

export default function (state = initialState, action) {
    switch (action.type) {
    case actions.GET_DEFAULT_COURSES_FOR_COUNTRY_SUCCESS: {
        return {
            ...state,
            defaultCourses: action.defaultCourses
        };
    }

    case actions.GET_COURSES_FOR_COUNTRY_SUCCESS: {
        return {
            ...state,
            courses: action.courses
        };
    }

    case actions.SAVE_DEFAULT_COURSES_FOR_COUNTRY_REQUEST: {
        return {
            ...state,
            dataSaved: false,
            saveSuccessful: null
        };
    }

    case actions.SAVE_DEFAULT_COURSES_FOR_COUNTRY_SUCCESS: {
        return {
            ...state,
            dataSaved: true,
            saveSuccessful: true
        };
    }

    case actions.SAVE_DEFAULT_COURSES_FOR_COUNTRY_FAILURE: {
        return {
            ...state,
            dataSaved: false,
            saveSuccessful: false
        };
    }

    case actions.GET_COURSES_SUCCESS: {
        return {
            ...state,
            defaultCourses: action.courses
        };
    }

    case actions.SAVE_DEFAULT_COURSES_REQUEST: {
        return {
            ...state,
            saveSuccessful: null,
            dataSaved: false
        };
    }

    case actions.SAVE_DEFAULT_COURSES_SUCCESS: {
        return {
            ...state,
            saveSuccessful: true,
            dataSaved: true,
            defaultCourses: action.defaultCourses
        };
    }

    case actions.SAVE_DEFAULT_COURSES_FAILURE: {
        return {
            ...state,
            saveSuccessful: false,
            dataSaved: false
        };
    }

    default:
        return { ...state };
    }
}



// WEBPACK FOOTER //
// ./app/containers/set-default-courses/reducer.js